function sortFunctionsFor(sortField) {
    switch (sortField) {
        case "openIdeas":
            return [
                it => it.totalIdeas,
                it => it.invertedNameLowerCase
            ];
        case "latestActivity":
            return [it => it.latestActivity];
        case "sentimentTodayValue":
            return [
                it => it.sentimentTodayValue,
                it => it.sentimentOneDayChange
            ];
        case "sentimentOneDayChange":
            return [
                it => it.sentimentOneDayChange,
                it => it.sentimentTodayValue
            ];
        case "priceChangeToday":
            return [it => it.priceChangeToday];
        case "earnings":
            return [
                it => it.closestEarningsDateSortOrder,
                it => it.nameLowerCase
            ];
        default:
            const propertyName = sortField + "LowerCase";
            return [it => it[propertyName]];
    }
}


function isInversed(field) {
    return (field === "openIdeas" || field === "latestActivity" || field === "sentimentTodayValue" || field === "sentimentOneDayChange" || field === "priceChangeToday");
}

function makeComparatorBuilder(reversed) {
    return (valueExtractor) => {
        return (a, b) => {
           const left = valueExtractor(a);
           const right = valueExtractor(b);

           if (left === null) {
              return right === null ? 0 : 1;
           }
           if (right === null) {
              return -1;
           }

           if (left > right) {
             return reversed ? -1 : 1;
           }
           if (left < right) {
             return reversed ? 1 : -1;
           }
           return 0;
        }
    }
}

function chainComparators(first, next) {
    return (a, b) => {
        const n = first(a, b);
        if (n === 0)
            return next(a, b);
        else
            return n;
    }
}

function sortWith(comparator) {
    return list => {
        const out = [...list];
        out.sort(comparator);
        return out;
    }
}

export function sortBasedOnState(list, sort) {
    const sortedList = list.slice();
    if (!(sort && sort.direction)) {
        return sortedList;
    }
    const reversed = sort.direction === "desc";
    const sortFunction = sortWithNullsLast(sort.field, reversed);
    return sortFunction(sortedList);
}

export function sortWithNullsLast(fieldName, reversed) {
    const valueExtractor = it => it[fieldName];
    return sortWith(makeComparatorBuilder(reversed)(valueExtractor));
}

export default function sort({ field, reversed }) {
    const comparatorBuilder = makeComparatorBuilder(reversed !== isInversed(field));
    const sortFunctions = sortFunctionsFor(field).map(comparatorBuilder);
    return sortWith(sortFunctions.reduce((acc, v) => chainComparators(acc, v), () => 0));
}
